import Resultat from "./Resultat";

import React from "react";
import Link from "next/link";

const Resultats = ({ resultats }) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {resultats.map((resultat, key) => {
          try {
            if (resultat.fields) {
              const adversaire = resultat.fields.adversaire;
              const adversaireLogo = resultat.fields.logoAdversaire && `https:${resultat.fields.logoAdversaire.fields.file.url}`;
              const competition = resultat.fields.competition;
              const bestOf = resultat.fields.bestOf;
              const dateMatch = resultat.fields.dateMatch;
              const infoSup = resultat.fields.infoSup;
              const scoreAdversaire = resultat.fields.scoreAdversaire;
              const scoreDeathrow = resultat.fields.scoreDeathrow;
              const equipeDeathrow: string = resultat.fields.equipeDeathrow?.fields.nom ? resultat.fields.equipeDeathrow.fields.nom : undefined;

              return (
                <div key={key} className="flex-shrink-0 snap-center">
                  <Resultat
                    adversaire={adversaire}
                    adversaireLogo={adversaireLogo}
                    competition={competition}
                    bestOf={bestOf}
                    dateMatch={dateMatch}
                    infoSup={infoSup}
                    scoreAdversaire={scoreAdversaire}
                    scoreDeathrow={scoreDeathrow}
                    equipeDeathrow={equipeDeathrow}
                  />
                </div>
              );
            }
          } catch (ex) {
            throw new Error(`Error while fetching last results : ${ex}`);
          }
        })}
      </div>
    </>
  );
};

export default Resultats;
